<template>
  <div id="devmgerji">
    <el-row>
      <el-button type="primary" icon="el-icon-plus" @click="dialogVisible_adddevice1=true">添加子账户</el-button>
      <el-button type="success" icon="el-icon-refresh" @click="reflash_devlist">刷新</el-button>
    </el-row>
    <el-table :data="tableData" style="width: 1320px" highlight-current-row border>
      <el-table-column type="index" width="100" label="编号 "></el-table-column>
      <el-table-column prop="node_name" label="网络节点" width="100"></el-table-column>
      <el-table-column prop="user_name" label="子账户名字 " width="200"></el-table-column>
      <el-table-column prop="user_level" label="子账户等级 " width="100"></el-table-column>
      <el-table-column prop="count" label="设备个数 " width="100"></el-table-column>
	  <el-table-column prop="beizhu" label="备注 " width="200"></el-table-column>

      <el-table-column prop="ctime" label="时间 " width="200"></el-table-column>

      <el-table-column label="操作[Operation]" width="300" align="center">
        <template slot-scope="scope">
          <el-badge class="item">
            <el-button
              type="warning"
              icon="el-icon-edit"
              @click.native.prevent="EditRow(scope.$index, tableData)"
              size="small"
              plain
            >编辑</el-button>
          </el-badge>

          <el-badge
            :value="tableData[scope.$index].shenhecount"
            class="item"
            :max="10"
            type="primary"
          >
            <el-button
              type="warning"
              icon="el-icon-edit"
              @click.native.prevent="refileRow(scope.$index, tableData)"
              size="small"
              plain
            >审核文件</el-button>
          </el-badge>

          <el-badge class="item">
            <el-button
              type="danger"
              icon="el-icon-delete"
              @click.native.prevent="goDeleteRow(scope.$index, tableData)"
              size="small"
              plain
            >删除</el-button>
          </el-badge>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="编辑设备"
      :visible.sync="dialogVisible_adddevice2"
      :before-close="handleClose_adddevice2"
      width="600px"
    >
      <template>
        <el-transfer
          v-model="valueT"
          width="600px"
          filterable
          :titles="['所有设备', '选中的']"
          :button-texts="['到左边', '到右边']"
          :format="{
				  noChecked: '${total}',
				  hasChecked: '${checked}/${total}'
				}"
          :data="Tdata"
        >
          <!--el-button class="transfer-footer" slot="left-footer" size="small">操作</el-button>
          <el-button class="transfer-footer" slot="right-footer" size="small">操作</el-button-->
        </el-transfer>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="func_save_ziuserdev">保存</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="添子账户"
      :visible.sync="dialogVisible_adddevice1"
      width="400px"
      :before-close="handleClose_adddevice1"
    >
      <div style=" margin: 15px; ">
        网络节点：
        <el-select v-model="nodeid" slot="prepend" placeholder="选择网络节点">
          <el-option v-for="item in options" :key="item.label" :label="item.label" :value="item.id">
            <span style="float: left">{{ item.label }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.nodeip }}</span>
          </el-option>
        </el-select>
      </div>

      <el-row>
        <el-tooltip class="item" effect="dark" content="建议使用该用户的手机号码" placement="top-start">
          <el-input style="width: 300px;" placeholder="子账户用户名" v-model="ziusername"></el-input>
        </el-tooltip>
      </el-row>
      <el-row>
        <el-tooltip class="item" effect="dark" content="密码为数字或者是英文字符" placement="top-start">
          <el-input
            style="width: 300px; margin-top: 10px;"
            placeholder="子账户密码"
            v-model="zipasswd"
            show-password
          ></el-input>
        </el-tooltip>
      </el-row>
	  <el-row>
	    <el-tooltip class="item" effect="dark" content="账号备注" placement="top-start">
	      <el-input
	        style="width: 300px; margin-top: 10px;"
	        placeholder="子账户备注信息"
	        v-model="zibeizhu"
	      ></el-input>
	    </el-tooltip>
	  </el-row>
      <el-row>
        <el-tooltip class="item" effect="dark" content="子用户等级不得高于自己等级" placement="top-start">
          <el-input-number
            v-model="userlevel"
            :min="1"
            :max="userlevel"
            style="width: 300px; margin-top: 10px;"
            label="用户等级"
          ></el-input-number>
        </el-tooltip>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="func_addziuserKey">添加子账户</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="审核文件"
      :visible.sync="dialogVisible_adddevice3"
      :before-close="handleClose_adddevice3"
      width="900px"
    >
      <div style="padding:10px 0;">
        <a-player
          :autoplay="autoplay"
          :music="songList"
          v-if="flag"
          mutex
          listmaxheight="10px"
          ref="player"
        ></a-player>
      </div>
      <el-table :data="tableDatafilelist" highlight-current-row border style="width: 800px">
        <el-table-column type="index" width="100" label="编号"></el-table-column>
        <el-table-column prop="filename" label="文件名" width="300"></el-table-column>
        <el-table-column prop="filesize" label="文件大小" width="100"></el-table-column>
        <el-table-column label="试听" width="100" align="center">
          <template slot-scope="scope">
            <el-button
              @click.native.prevent="playurl(scope.$index, tableDatafilelist)"
              type="text"
              size="small"
            >播放</el-button>
          </template>
        </el-table-column>
        <el-table-column v-if="isroot" label="审核" width="100" align="center">
          <template slot-scope="scope">
            <el-switch
              active-value="1"
              inactive-value="0"
              v-model="tableDatafilelist[scope.$index].enable"
              @change="abletask( scope.$index, tableDatafilelist)"
            ></el-switch>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import VueAplayerfuck from "vue-aplayer";
import axios from "axios";
axios.defaults.headers = {
  "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
};
export default {
  components: {
    //别忘了引入组件
    "a-player": VueAplayerfuck
  },
  data() {
    return {
      options: [],
      nodeid: "",
      zipasswd: "",
	  zibeizhu:"",
      ziusername: "",
      group_name: "",
      tableData: [],
      dialogVisible_adddevice1: false,
      dialogVisible_adddevice2: false,
      dialogVisible_adddevice3: false,
      name_adddevice: "",
      seed_adddevice: "",
      seed_ofnode: "",
      tag1: "自定义标签A可选",
      tag2: "自定义标签B可选",
      type: "1",
      device_status: "1",
      sqr_adddevice: "",
      save_backdata: "",
      dialogVisible_save_back: false,
      dialogVisible_save_back_detail: false,
      valueT: [],
      Tdata: [],
      fornodeid: -1,
      forgid: -1,
      userlevel: 1,
      autoplay: false,
      isroot: false,
      fileList: [],
      tableDatafilelist: [],
      songList: [],
      flag: false
    };
  },
  created() {
    this.userlevel = sessionStorage.getItem("user_level") - 1;
    this.reflash_devlist();
    if (sessionStorage.getItem("master_id") == -1) {
      this.isroot = true;
    }
  },
  methods: {
    goDeleteRow(index, rows) {
      this.$confirm("此操作将永久删除该用户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.deleteRow(index, rows);
        })
        .catch(() => {});
    },
    open5() {
      this.$alert(this.save_backdata, "配置详情", {
        dangerouslyUseHTMLString: false
      });
    },
    abletask(index, rows) {
      console.log("fuckser");
      axios
        .get("/Change_file_status.php", {
          params: {
            file_id: rows[index].id,
            enable: rows[index].enable
          }
        })
        .then(
          function(res) {
            if (res.data.res) {
              this._get_timer_tasklist_s(rows[index].task_enable, index);
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    playurl(index, rows) {
      this.flag = false;
      console.log(rows[index].url);
      console.log(rows[index].filename);
      let obj = {};
      let murl = rows[index].url;
      let lname = rows[index].filename;
      let auth = "试听上传歌曲";
      obj.title = lname;
      obj.author = auth;
      obj.url = murl;
      //把数据一个个push到songList数组中，在a-player标签中使用 :music="songList" 就OK了
      this.songList = obj;
      this.flag = true;
      this.autoplay = true;
    },
    func_addziuserKey() {
      if (this.ziusername.trim() == "" || this.ziusername.length < 11) {
        this.$notify.success({
          title: "Info",
          message: "用户名需要11位数字手机号码",
          showClose: true
        });
        return;
      }
      if (this.nodeid == "") {
        this.$notify.success({
          title: "Info",
          message: "您还没有选者设备节点",
          showClose: true
        });
        return;
      }
      if (this.zipasswd == "" || this.zipasswd.length < 7) {
        this.$notify.success({
          title: "Info",
          message: "密码必须为7位以上 英文或数字混写",
          showClose: true
        });
        return;
      }
      if (
        this.userlevel >= 1 &&
        this.userlevel < sessionStorage.getItem("user_level") &&
        sessionStorage.getItem("user_type") == 0
      ) {
		 if(this.zibeizhu.trim() == ""){
			this.zibeizhu="NOTHING";
		 }
        let data = new FormData();
        data.append("username", sessionStorage.getItem("username"));
        data.append("passwd", sessionStorage.getItem("passwd"));
        data.append("nodeid", this.nodeid);
        data.append("zipasswd", this.zipasswd);
        data.append("ziusername", this.ziusername);
		data.append("zibeizhu", Base64.encode(this.zibeizhu));
        data.append("level", this.userlevel);
        axios
          .post("/new_ziuser.php", data)
          .then(
            function(res) {
              if (res.data.res) {
                this.reflash_devlist();
              } else {
                this.$notify.success({
                  title: "Info",
                  message: "添加出错 可能用户名已经被占用",
                  showClose: false
                });
              }
            }.bind(this)
          )
          .catch(function(res) {
            console.log(res);
          });
      } else {
        this.$notify.success({
          title: "Info",
          message: "用户等级不正确",
          showClose: true
        });
      }
      this.dialogVisible_adddevice1 = false;
    },

    func_save_ziuserdev() {
      console.log(this.valueT.length);
      if (this.valueT.length == 0) {
        return;
      }
      console.log(this.Tdata);
      console.log(this.valueT);
      let strseed = "";
      this.valueT.forEach(item => {
        strseed += item;
        strseed += "|";
      });
      strseed = strseed.substr(0, strseed.length - 1);
      let data = new FormData();
      data.append("username", sessionStorage.getItem("username"));
      data.append("passwd", sessionStorage.getItem("passwd"));
      data.append("nodeid", this.fornodeid);
      data.append("ziuserid", this.forgid);
      data.append("type", 1);
      data.append("seed", strseed);
      axios
        .post("/add_ziuser_devices.php", data)
        .then(
          function(res) {
            if (res.data.res) {
              this.reflash_devlist();
              this.dialogVisible_adddevice = false;
            } else {
              this.$notify.success({
                title: "Info",
                message: "添加出现异常",
                showClose: false
              });
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
      this.dialogVisible_adddevice2 = false;
    },
    func_addgoup() {},

    func_adddevic() {
      this.dialogVisible_adddevice2 = true;
    },

    deleteRow(index, rows) {
      let ziuserid = rows[index].ziuserid;
      let username = sessionStorage.getItem("username");
      let passwd = sessionStorage.getItem("passwd");
      axios
        .get("/del_ziuser.php", {
          params: {
            ziuserid: ziuserid,
            username: username,
            passwd: passwd
          }
        })
        .then(
          function(res) {
            if (res.data.res) {
              this.$notify.success({
                title: "Info",
                message: "删除成功",
                showClose: false
              });
              rows.splice(index, 1);
              this.reflash_devlist();
            } else {
              this.$notify.success({
                title: "Info",
                message: "删除失败",
                showClose: false
              });
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    EditRow(index, rows) {
      this.dialogVisible_adddevice2 = true;
      let data = new FormData();
      data.append("username", sessionStorage.getItem("username"));
      data.append("passwd", sessionStorage.getItem("passwd"));
      data.append("nodeip", rows[index].nodeip);
      data.append("nodeid", rows[index].nodeid);
      data.append("ziuserid", rows[index].ziuserid);
      data.append("nodeport3", rows[index].nodeport3);
      data.append("nodeport5", rows[index].nodeport5);
      data.append("nodeport1", rows[index].nodeport1);
      data.append("nodeport4", rows[index].nodeport4);
      data.append("nodeport2", rows[index].nodeport2);
      console.log(rows[index].nodeip);
      console.log(rows[index].nodeid);
      console.log(rows[index].ziuserid);
      axios
        .post("/get_ziuser_nodedevs.php", data)
        .then(
          function(res) {
            if (res.data.res) {
              this.Tdata = res.data.dev_info;
              this.valueT = res.data.dev_info_S;
              this.forgid = rows[index].ziuserid;
              this.fornodeid = rows[index].nodeid;
              this.dialogVisible_adddevice = true;
            } else {
              this.$notify.success({
                title: "Info",
                message: "添加出现异常1",
                showClose: false
              });
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    refileRow(index, rows) {
      this.dialogVisible_adddevice3 = true;

      axios
        .get("/Get_file_Listbyid.php", {
          params: {
            username: rows[index].user_name,
            ziuserid: rows[index].ziuserid,
            kind: "mp3"
          }
        })
        .then(
          function(res) {
            if (res.data.res) {
              this.tableDatafilelist = res.data.file;
              this.tableDatafilelist.forEach((item, index) => {
                item.filename = Base64.decode(item.filename);
                item.filesize = item.filesize;
              });
              this.$forceUpdate();
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    handleClose_adddevice1() {
      this.dialogVisible_adddevice1 = false;
    },
    handleClose_adddevice2() {
      this.dialogVisible_adddevice2 = false;
    },
    handleClose_adddevice3() {
      this.dialogVisible_adddevice3 = false;
      this.reflash_devlist();
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 1) {
        return "warning-row";
      } else if (rowIndex === 3) {
        return "success-row";
      }
      return "";
    },
    reflash_devlist: function() {
      axios
        .get("/get_user_node.php", {
          params: {
            username: sessionStorage.getItem("username"),
            passwd: sessionStorage.getItem("passwd")
          }
        })
        .then(
          function(res) {
            if (res.data.res) {
              this.options = res.data.outlableid;

              this.$forceUpdate();
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });

      axios
        .get("/get_ziuser_info.php", {
          params: {
            username: sessionStorage.getItem("username"),
            passwd: sessionStorage.getItem("passwd")
          }
        })
        .then(
          function(res) {
            if (res.data.res) {
              this.tableData = res.data.dataJson;
              this.$forceUpdate();
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.el-select .el-input {
  width: 200px;
}
.el-transfer {
  text-align: left;
}

#devmgerji {
  padding-top: 20px;
  width: 100%;
}
.el-table {
  margin: 20px auto;
}
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
.item {
  margin-top: 10px;
  margin-right: 6px;
}
</style>



// WEBPACK FOOTER //
// src/xxxvue/erjizhanghu.vue